/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Custom_Max_CharsInputs */



/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Live_Caption_Custom_Max_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_custom_max_chars = /** @type {((inputs?: Live_Caption_Custom_Max_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Custom_Max_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coutume")
	if (locale === "de") return /** @type {LocalizedString} */ ("Brauch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costume")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обычай")
	if (locale === "es") return /** @type {LocalizedString} */ ("Costumbre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风俗")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवाज़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personalizado")
	return /** @type {LocalizedString} */ ("Custom")
});